import { Validator } from '@vista-digital/validator';
import { defaultMemberTransactionListAssets, memberTransactionListAssetsValidator } from './assets';
import { defaultMemberTransactionListConfig, memberTransactionListConfigValidator } from './config';
import { defaultMemberTransactionListDisplayText, memberTransactionListDisplayTextValidator } from './display-text';
export const memberTransactionListPropsValidator = Validator.object({
    assets: memberTransactionListAssetsValidator,
    config: memberTransactionListConfigValidator,
    displayText: memberTransactionListDisplayTextValidator
});
export const defaultMemberTransactionListProps = {
    config: defaultMemberTransactionListConfig,
    displayText: defaultMemberTransactionListDisplayText,
    assets: defaultMemberTransactionListAssets
};
